import { motion } from '@eversports/react-components/design-tokens/motion'
import ActionOutcome from '@eversports/react-components/patterns/ActionOutcome'
import Heading from '@eversports/react-components/primitives/Heading'
import Text from '@eversports/react-components/primitives/Text'
import { parse } from 'query-string'

import { useLocation } from 'react-router-dom'
import { Localized } from '../localization/react'

const PasswordResetRequested = () => {
  const location = useLocation()
  const query = parse(location.search)
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ ease: 'easeInOut' }}
    >
      <ActionOutcome type="success">
        <Heading is="h1" data-testid="password-reset-requested-header">
          <Localized id="password-reset-requested-header" />
        </Heading>
        <Text textAlign="center">
          <Localized id="password-reset-requested-text" />
        </Text>
        {query && query.activationLink && (
          <>
            <Text textAlign="center" fontWeight="bold">
              DEV ONLY LOG OF activationLink
            </Text>
            <a data-testid="activation-link" href={query.activationLink as string}>
              <Text textAlign="center">{query.activationLink}</Text>
            </a>
          </>
        )}
      </ActionOutcome>
    </motion.div>
  )
}

export default PasswordResetRequested
